import { useQueryClient } from "@tanstack/react-query";
import ImageModal from "components/ui/ImageModal";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import { useSettingContext } from "context/SettingContext";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { useGetParticularList } from "../apis/GetParticularData";
import { useInView } from "react-intersection-observer";
import { handleRevert } from "../utils/handleRevert";
import { Grid } from "@mui/material";
import SyncCardComp from "../components/SyncCardComp";
import { actionTypeToRight } from "../utils/actionTypeToNameRight";

const SyncActionTypePage = () => {
  const { setSyncButton, setSingleRevertModal, singleRevertModal, setSyncButtonName, openImageModal, setOpenImageModal, search, setSearch, setSyncSubPageCount } = useSettingContext();
  const permission = usePermissions();
  const [currentSelctelement, setCurrentSelctelement] = useState(null);
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "vie
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;;
  const queryClient = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(null);
  const [syncData, setSyncData] = useState([]);
  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === syncData?.length - 1 || syncData?.length === 0;

  const actionTypeName = location.pathname.split("/")[3];

  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount } = useGlobalContext();

  const { data, fetchNextPage, isFetchingNextPage, isLoading, error } = useGetParticularList({ actionType: actionTypeName, search, limit: 10 });

  const SingleSyncBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: () => setSingleRevertModal(false),
      },
      {
        btnName: "Revert",
        bgColor: "#50C878",
        click: async () => {
          await handleRevert(currentSelctelement?._id);
          setSingleRevertModal(false);
          queryClient.invalidateQueries("getParticularSyncList");
          queryClient.removeQueries("getParticularSyncList");
        },
      },
    ],
    [currentSelctelement]
  );

  const handleClick = (data) => {
    setSingleRevertModal(true);
    setCurrentSelctelement(data);
  };

  const handleImageModal = (data) => {
    setOpenImageModal(true);
    setCurrentSelctelement(data);
  };

  const handleNextClick = () => {
    if (currentIndex < syncData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = syncData[newIndex];
      setOpenImageModal(true);
      setCurrentSelctelement(nextItem);
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = syncData[newIndex];
      setOpenImageModal(true);
      setCurrentSelctelement(prevItem);
    }
  };

  useEffect(() => {
    if (syncData?.length && currentSelctelement?.styleNumber) {
      const index = syncData.findIndex((item) => item?.styleNumber === currentSelctelement.styleNumber);
      setCurrentIndex(index);
    }
  }, [currentSelctelement]);

  const { ref, inView } = useInView();

  let newState = {
    name: location.state.name || "",
  };

  useEffect(() => {
    setSyncSubPageCount(data?.pages[0].totalCount);
    if (data?.pages[0].totalCount === 0) navigate("/Setting/synchronize", { state: newState });
  }, [data]);

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  useEffect(() => {
    setSyncButtonName(actionTypeName);
    setSyncButton(true);
    return () => {
      setSyncButtonName(null);
      setSyncButton(false);
      setSearch("");
      setSyncSubPageCount(0);
    };
  }, []);

  useEffect(() => {
    setFilterChangeCount(data?.pages[0]?.totalCount);
    // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
    setDisplayCount(true);
    let combineData = data?.pages?.flatMap((page) => page?.syncAllData);
    setSyncData(combineData);
    return () => {
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  if (isLoading) return <ProductSkeleton count={4} />;

  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "30px",
          rowGap: "32px",
          marginTop: "15px",

          // overflowY: "auto",
          // maxHeight: "78vh",
          // "&::-webkit-scrollbar": {
          //   display: "none", // Hide scrollbar for Chrome, Safari, Edge
          // },
        }}
        className="Grid-padding"
      >
        {data?.pages
          ?.flatMap((page) => page.syncAllData)
          ?.map((data, index) => (
            <Grid item>
              {/* <Card key={index} data={data} handleClick={handleClick} handleImage={handleImageModal} actionType="subCategoryName" /> */}
              <SyncCardComp key={index} data={data} handleClick={handleClick} handleImage={handleImageModal} actionType={actionTypeName} />
            </Grid>
          ))}
        <div ref={ref}>{isFetchingNextPage && data.pages.length > 10 && <ProductSkeleton count={2} />}</div>
      </Grid>

      {/* Sync Revertmodal */}
      <RemoveModal
        open={singleRevertModal}
        setOpen={setSingleRevertModal}
        btnInfo={SingleSyncBtnInfo}
        heading={`Are you sure you want to revert ${currentSelctelement?.styleNumber}?`}
        cumWidth="440px"
      />
      {/* ImageModal */}
      <ImageModal
        open={openImageModal}
        handleClose={() => setOpenImageModal(false)}
        data={currentSelctelement}
        hasAccessToSeeWatermark={hasAccessToSeeWatermark}
        nextClick={() => handleNextClick()}
        prevClick={() => handlePrevClick()}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
      />
    </>
  );
};

export default SyncActionTypePage;
